export var ShopThumbType;
(function(ShopThumbType) {
    ShopThumbType["PCP"] = 'pcp';
    ShopThumbType["COMMISSION"] = 'commission';
    ShopThumbType["PRINT"] = 'print';
    ShopThumbType["DAS"] = 'das';
})(ShopThumbType || (ShopThumbType = {}));
